import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const mapStateToProps = (state) => ({ ...state });

class FromInputValue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { depatureCity } = this.props;
    return <div>{depatureCity.name}</div>;
  }
}

FromInputValue.propTypes = {
  depatureCity: PropTypes.instanceOf(Object).isRequired,
};

export default connect(mapStateToProps, {})(FromInputValue);
